import React, { useRef, useState } from 'react'
import Carousel from './Carousel'
import PopupAlert from "./Popupalert";
import { NavLink } from 'react-router-dom'
import { FaLocationDot } from "react-icons/fa6";
import { IoMdCall } from "react-icons/io";
import { MdEmail } from "react-icons/md";
import emailjs from '@emailjs/browser';
const Home = () => {
    const teamdata = [
        {
            title: "Nimra Frontend Developer",
            para: '"As a web developer, I craft digital wonders.With a passion for pixel perfection, I transform your ideas into interactive websites.Let"s create your online dreams together."',
            link: "https://nimra-ali.netlify.app/",
        },
        {
            title: "Rizwan React Js Developer",
            para: '" As a web developer, I craft digital wonders. With a passion for pixel perfection, I transform your ideas into interactive websites. Let"s create your online dreams together."',
            link: "https://rizwan7351.bio.link/",

        },
        {
            title: "Aiman Fareed Marketing Expert",
            para: '"As a digital media virtuoso, I shape captivating narratives. With finesse in content alchemy, I elevate your brand"s tale, sculpting online wonders that spark engagement and allure effortlessly."',
            link: "https://aimanfareed.netlify.app/",

        },
        {
            title: "Shabina Frontend Developer",
            para: '"As a web developer, I craft digital wonders.With a passion for pixel perfection, I transform your ideas into interactive websites.Let"s create your online dreams together."',
            link: "https://www.linkedin.com/in/shabina-tariq-070110294/",

        }

    ]
    const [pendding, setpendding] = useState(false);
    const form = useRef();
    const sendEmail = (e) => {
        e.preventDefault();
        setpendding(true);
        emailjs.sendForm('service_5uiwzca', 'template_rn3cwrc', form.current, 'HBXuz37i_LNxr3Iep')
            .then((result) => {
                setpendding(false);
                console.log(result.text);
                alert("We are available to you very quickly")
                form.current.reset();
            }, (error) => {
                setpendding(false);
                console.log(error.text);
                form.current.reset();
                alert("You are making some mistakes while filling the form")
            });
    };
    return (
        <>
            <PopupAlert />
            <section className='header d-flex align-items-center'>
                <div className="container">
                    <div className="row d-flex align-items-center">
                        <div className="col-lg-7 my-2 animate__animated animate__backInDown">
                            <h1>Muhammad Rizwan </h1>
                            <p>I am a professional web developer responsible for crafting the digital landscapes we explore every day. With expertise in programming languages like HTML, CSS, JavaScript, and more, I can transform creative designs into functional websites. A web developer ensure that websites are not only visually appealing but also user-friendly and responsive across various devices. Whether it's building dynamic web applications, optimizing site performance, or troubleshooting coding issues, web developers are the architects behind the online experiences that connect people and information in the digital age. Their commitment to staying up-to-date with evolving technologies keeps the internet evolving and thriving.</p>
                            <NavLink to="https://rizwan7351.bio.link/" className='btn-button'>GET STARTED</NavLink>
                        </div>
                        <div className="col-lg-5 animate__animated animate__bounceInUp animate__delay-1s">
                            <img src="img/main.webp" className='img-fluid' alt="Main Header Image" />
                        </div>
                    </div>
                </div>
            </section>
            <section className="about d-flex align-items-center">
                <div className="container">
                    <div className="row d-flex align-items-center">
                        <div className="col-lg-5 my-2">
                            <img src="img/about.webp" className='img-fluid' alt="About Image" />
                        </div>
                        <div className="col-lg-7 my-2">
                            <h6 className='text-dark'>Frontend Development</h6>
                            <h1>ABOUT ME</h1>
                            <p>Hello there! I'm passionate about web development and delighted to introduce myself. I am a skilled and dedicated web developer with a keen eye for clean and functional designs. With several years of experience in the field, I have honed my skills in front-end development, as well as proficiency in various programming languages like HTML, CSS, JavaScript, JQuery, Bootstrap, React Bootstrap, and React J's I thrive on creating dynamic and interactive websites that provide exceptional user experiences. My expertise extends to responsive web design, ensuring seamless compatibility across multiple devices and browsers. I am well-versed in popular frameworks and libraries, such as React.js and Animated J's, and  Collaborating with clients and colleagues is something I truly enjoy, as I believe effective teamwork is crucial to the success of any project. I stay up to date with the latest industry trends and technologies to deliver innovative solutions that exceed expectations. My goal is to leverage my technical skills and creativity to develop cutting-edge websites that leave a lasting impression. Let's connect and bring your web development vision to life!</p>
                        </div>
                    </div>
                </div>
            </section>
            <section className="services d-flex align-items-center">
                <div className="container">
                    <div className="row">
                        <h1 className='text-center display-1'>Fastest Way To Achieve Success.</h1>
                        <div className="col-lg-2 col-md-4 my-2 d-flex align-items-stretch">
                            <div className="box w-100">
                                <NavLink to="/Web_Development"> <img src="img/web.png" alt='Web Development' className='w-25' />
                                    <h5>Web Development</h5></NavLink>
                            </div>
                        </div>
                        <div className="col-lg-2 col-md-4 my-2 d-flex align-items-stretch">
                            <div className="box w-100">
                                <NavLink to="/Software_Development"><img src="img/Software.png" alt='Software Developer' className='w-25' />
                                    <h5>Software Development</h5></NavLink>
                            </div>
                        </div>
                        <div className="col-lg-2 col-md-4 my-2 d-flex align-items-stretch">
                            <div className="box w-100">
                                <NavLink to="/Graphic_Design"><img src="img/Graphic.png" alt='Graphic Designer' className='w-25' />
                                    <h5>Graphic Designing</h5></NavLink>
                            </div>
                        </div>
                        <div className="col-lg-2 col-md-4 my-2 d-flex align-items-stretch">
                            <div className="box w-100">
                                <NavLink to="Web_Application"><img src="img/desktop.png" alt='Dekstop' className='w-25' />
                                    <h5>Web Application</h5></NavLink>
                            </div>
                        </div>
                        <div className="col-lg-2 col-md-4 my-2 d-flex align-items-stretch">
                            <div className="box w-100">
                                <NavLink to="/Android_Development"><img src="img/Android.png" alt='Android' className='w-25' />
                                    <h5>Android Development</h5></NavLink>
                            </div>
                        </div>
                        <div className="col-lg-2 col-md-4 my-2 d-flex align-items-stretch">
                            <div className="box w-100">
                                <NavLink to="/IOS_Development"><img src="img/IOS.png" alt='IOS Developer' className='w-25' />
                                    <h5>IOS Development</h5></NavLink>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* <section className='team'>
                <div className="container">
                    <h1>Team</h1>
                    <p>"Our team is a bundle of adorable planners and doers. We craft sweet plans and turn them into even sweeter realities with our hard work and dedication."</p>
                    <div className="row">
                        {teamdata.map((data, index) => (
                            <>
                                <div className="col-lg-3 col-md-6 my-2" key={index}>
                                    <div className="card">
                                        <div className="card-body">
                                            <h5 style={{ fontFamily: "heading" }}>{data.title}</h5>
                                            <p>{data.para}</p>
                                            <NavLink className='btn-button' to={data.link} target='_rizwan'>Read More</NavLink>
                                        </div>
                                    </div>
                                </div>
                            </>
                        ))}
                    </div>
                </div>
            </section> */}
            <section className="call-to-action">
                <div className="container">
                    <div className="row d-flex align-items-center text-center">
                        <div className="col-lg-4 my-2">
                            <h1>CALL TO ACTION</h1>
                        </div>
                        <div className="col-lg-4"> </div>
                        <div className="col-lg-4 my-2">
                            <NavLink to='img/pdf.pdf' className='btn-button' download>Download My Resume</NavLink>
                        </div>
                    </div>
                </div>
            </section>
            <section className="contact d-flex align-items-end">
                <div className="container">
                    <div className="row d-flex align-items-center">
                        <div className="col-lg-5">
                            <div className="content">
                                <div className="d-flex flex-wrap">
                                    <div className="left mt-2"><FaLocationDot /></div>
                                    <div className="right">
                                        <h5>Location:</h5>
                                        <p>Lahore Punjab Pakistan</p>
                                    </div>
                                </div>
                                <div className="d-flex flex-wrap">
                                    <div className="left mt-2"><MdEmail /></div>
                                    <div className="right">
                                        <h5>Email:</h5>
                                        <p>ranarizwan7351@gmail.com</p>
                                    </div>
                                </div>
                                <div className="d-flex flex-wrap">
                                    <div className="left mt-2"><IoMdCall /></div>
                                    <div className="right">
                                        <h5>Call:</h5>
                                        <p>+92 (0324-5097351)</p>
                                    </div>
                                </div>
                                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d54423.914658935886!2d74.30097511157088!3d31.510571123574543!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39190427303d1d9b%3A0x98af47ff5799036e!2zQXJmYSBJVCBUb3dlciDYp9ix2YHYuSDYotim24wg2bnbjCDZudin2YjYsQ!5e0!3m2!1sen!2s!4v1705744590848!5m2!1sen!2s" width="100%" height="300px" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                            </div>
                        </div>
                        <div className="col-lg-7 my-4">
                            <div className="content">
                                <h2>CHAT WITH US</h2>
                                <form ref={form} onSubmit={sendEmail}>
                                    <div className="d-flex">
                                        <div className="form-group w-100">
                                            <label>Your Name</label>
                                            <input required type="text" name="name" placeholder='Name' className='form-control my-2 rizwan-input' />
                                        </div> &nbsp;
                                        <div className="form-group w-100">
                                            <label>Your Email</label>
                                            <input required type="email" name="email" placeholder='Email' className='form-control my-2 rizwan-input' />
                                        </div>
                                    </div>
                                    <div className="d-flex">
                                        <div className="form-group w-100">
                                            <label>Phone Number </label>
                                            <input required type="phone" maxLength="11" name="phone" placeholder='Number' className='form-control my-2 rizwan-input' />
                                        </div> &nbsp;
                                        <div className="form-group w-100">
                                            <label>Your Subject</label>
                                            <input required type="text" name="subject" placeholder='Subject' className='form-control my-2 rizwan-input' />
                                        </div>
                                    </div>
                                    <textarea required className='form-control rizwan-input' name="sms" placeholder='Please type a short  Message' cols="30" rows="10"></textarea>
                                    <br />
                                    <div className="text-right">
                                        <button className='nav-btn text-dark' disable={pendding ? true : false}>{pendding ? "Loading..." : "Send Message"}</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Carousel />
        </>
    )
}
export default Home